// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"cc45db0f","239":"0d04f57c","389":"6047e1fe","443":"09573755","453":"540c4fc1","460":"28635505","732":"f199f7e6","857":"d14ef4f3","977":"e7f02709"}[chunkId] + ".chunk.js";
};